//import React, { useState, useEffect } from "react";
//import Loading from "../../component/Loading/Loading";
//import { FaRegWindowClose } from "react-icons/fa";
//import { useSelector } from 'react-redux';
//import AlertMsg from '../../component/AlertMsg/AlertMsg';
//import { AiOutlineSortAscending } from "react-icons/ai";
//import Pagination from "../../utils/Pagenation/Pagenation";
//import useAxiosInstance from "../../services/useAxiosInstance";
//import { Plus, Pencil, Eye, Search } from "lucide-react";
//import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

//const AddSlot = () => {
//  const axiosInstance = useAxiosInstance();
//  const communityId = useSelector((state) => state.auth.communityId);
//  const userId = useSelector((state) => state.auth.userId);
//  const [amenitySlots, setAmenitySlots] = useState([]);
//  const [amenities, setAmenities] = useState([]);
//  const [isLoading, setIsLoading] = useState(true);
//  const [selectedAmenityType, setSelectedAmenityType] = useState(null);
//  const [showViewModal, setShowViewModal] = useState(false);
//  const [showAddModal, setShowAddModal] = useState(false);
//  const [formData, setFormData] = useState({
//    activeStatus: true,
//    amenityId: 0,
//    communityId: communityId,
//    amenitySlotId: 0,
//    name: "",
//    startTime: "",
//    endTime: "",
//  });
//  const [errors, setErrors] = useState({});
//  const [errorMessage, setErrorMessage] = useState("");

//  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

//  useEffect(() => {
//    fetchAmenityTypes();
//    fetchAmenities();
//  }, []);

//  const fetchAmenityTypes = () => {
//    setIsLoading(true);
//    axiosInstance
//      .get(`/api/public/amenityslot/findByCommunityId/${communityId}`)
//      .then((response) => {
//        setAmenitySlots(response.data);
//      })
//      .catch((error) => {
//        console.error("Error fetching amenity types:", error);
//      })
//      .finally(() => {
//        setIsLoading(false);
//      });
//  };

//  const fetchAmenities = () => {
//    axiosInstance
//      .get(`/api/public/amenity/findByCommunityId/${communityId}`)
//      .then((response) => {
//        setAmenities(response.data);
//      })
//      .catch((error) => {
//        console.error("Error fetching amenities:", error);
//      });
//  };

//  const handleView = (amenitySlotId) => {
//    const selectedAmenity = amenitySlots.find(
//      (amenitySlot) => amenitySlot.amenitySlotId === amenitySlotId
//    );
//    setSelectedAmenityType(selectedAmenity);
//    setShowViewModal(true);
//  };

//  const closeModal = () => {
//    setSelectedAmenityType(null);
//    setShowViewModal(false);
//    setShowAddModal(false);
//    setFormData({
//      activeStatus: true,
//      amenityId: 0,
//      amenitySlotId: 0,
//      name: "",
//      startTime: "",
//      endTime: "",
//    });
//    setErrors({});
//    setErrorMessage("");
//  };

//  const handleAddAmenityType = () => {
//    setShowAddModal(true);
//  };

//  const handleChange = (e) => {
//    const { name, value } = e.target;
//    setFormData({
//      ...formData,
//      [name]: name === "activeStatus" ? e.target.checked : value,
//    });
//  };

//  const handleAddNewAmenitySlot = () => {
//    const newErrors = {};

//    if (!formData.amenityId) {
//      newErrors.amenityId = "Amenity ID is required";
//    }

//    if (!formData.name) {
//      newErrors.name = "Amenity Slot Name is required";
//    }

//    if (!formData.startTime) {
//      newErrors.startTime = "Start Time is required";
//    }

//    if (!formData.endTime) {
//      newErrors.endTime = "End Time is required";
//    }

//    if (Object.keys(newErrors).length > 0) {
//      setErrors(newErrors);
//      return;
//    }

//    const newAmenitySlotData = {
//      ...formData,
//      startTime: `${formData.startTime}:00`,
//      endTime: `${formData.endTime}:00`,
//    };
//    setShowAddModal(false);
//    setIsLoading(true);
//    axiosInstance
//      .post(`/api/public/amenityslot/amenityslot/add`, newAmenitySlotData)
//      .then((response) => {
//        setFormData({
//          activeStatus: true,
//          amenityId: 0,
//          amenitySlotId: 0,
//          name: "",
//          startTime: "",
//          endTime: "",
//        });
//        console.log("Amenity slot added successfully:", response.data);
//        setAlert({ visible: true, message: 'Amenity slot added successfully!', type: 'success' });
//        fetchAmenityTypes();
//        setIsLoading(false);
//      })
//      .catch((error) => {
//        console.error("Error adding new amenity slot:", error);
//        setAlert({ visible: true, message: 'Error adding new amenity slot. Please try again', type: 'error' });
//        setErrorMessage("Error adding new amenity slot. Please try again.");
//        setIsLoading(false);
//      });
//  };

//  const handleEditAmenitySlot = () => {
//    const { amenitySlotId, ...updatedData } = formData;

//    const newErrors = {};

//    if (!updatedData.amenityId) {
//      newErrors.amenityId = "Amenity ID is required";
//    }

//    if (!updatedData.name) {
//      newErrors.name = "Amenity Slot Name is required";
//    }

//    if (!updatedData.startTime) {
//      newErrors.startTime = "Start Time is required";
//    }

//    if (!updatedData.endTime) {
//      newErrors.endTime = "End Time is required";
//    }

//    if (Object.keys(newErrors).length > 0) {
//      setErrors(newErrors);
//      return;
//    }
//    setShowAddModal(false);
//    setIsLoading(true);
//    axiosInstance
//      .put(`/api/public/amenityslot/amenityslot/update/${amenitySlotId}`, updatedData)
//      .then((response) => {
//        setFormData({
//          activeStatus: true,
//          amenityId: 0,
//          amenitySlotId: 0,
//          name: "",
//          startTime: "",
//          endTime: "",
//        });
//        console.log("Amenity slot updated successfully:", response.data);
//        setAlert({ visible: true, message: 'Amenity slot updated successfully!', type: 'success' });
//        fetchAmenityTypes();
//        setIsLoading(false);
//        const updatedAmenityTypes = amenitySlots.map((amenitySlot) =>
//          amenitySlot.amenitySlotId === amenitySlotId
//            ? { ...amenitySlot, ...updatedData }
//            : amenitySlot
//        );
//        setAmenitySlots(updatedAmenityTypes);
//      })
//      .catch((error) => {
//        console.error("Error updating amenity slot:", error);
//        setAlert({ visible: true, message: 'Error updating amenity slot. Please try again', type: 'error' });
//        setErrorMessage("Error updating amenity slot. Please try again.");
//        setIsLoading(false);
//      });
//  };

//  const [currentPage, setCurrentPage] = useState(0);
//  const itemsPerPage = 5;
//  const [sortOrder, setSortOrder] = useState('none');

//  const handleSort = () => {
//    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
//  };

//  const sortedAmenitySlot = [...amenitySlots].sort((a, b) => {
//    if (sortOrder === 'asc') {
//      return a.name.localeCompare(b.name);
//    } else if (sortOrder === 'desc') {
//      return b.name.localeCompare(a.name);
//    }
//    return 0;
//  });
//  const pageCount = Math.ceil(amenitySlots.length / itemsPerPage);
//  const currentAmenitySlot = sortedAmenitySlot.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

//  // Modal footers
//  const viewModalFooter = (
//    <div className="flex justify-end">
//      <button
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={() => setShowViewModal(false)}
//      >
//        Close
//      </button>
//    </div>
//  );

//  const addModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        type="button"
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        type="button"
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={formData.amenitySlotId ? handleEditAmenitySlot : handleAddNewAmenitySlot}
//      >
//        {formData.amenitySlotId ? "Update" : "Add"}
//      </button>
//    </div>
//  );

//  return (
//    <div className="bg-gray-50 min-h-screen md:p-4">
//      {isLoading && <Loading />}
//      {!isLoading && (
//        <div className="max-w-7xl mx-auto">
//          {alert.visible && (
//            <AlertMsg
//              message={alert.message}
//              type={alert.type}
//              onClose={() => setAlert({ ...alert, visible: false })}
//            />
//          )}
//          <div className="flex justify-between items-center mb-6">
//            <h1 className="text-2xl font-bold text-gray-800">Amenity Slots</h1>
//            <div className="flex items-center">
//              <button
//                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
//                onClick={handleAddAmenityType}
//              >
//                <Plus size={18} />
//                <span>Add</span>
//              </button>
//            </div>
//          </div>

//          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//            <div className="overflow-x-auto">
//              <table className="min-w-full divide-y divide-gray-200">
//                <thead className="bg-blue-400">
//                  <tr>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Slot Name
//                      <button
//                        onClick={handleSort}
//                      >
//                        <AiOutlineSortAscending className="inline ml-1" />
//                      </button>
//                    </th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amenity Name</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Start Time</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">End Time</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Status</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Action</th>
//                  </tr>
//                </thead>
//                <tbody className="bg-white divide-y divide-gray-200">
//                  {currentAmenitySlot.length === 0 ? (
//                    <tr>
//                      <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
//                    </tr>
//                  ) : (
//                    currentAmenitySlot.map((amenitySlot) => (
//                      <tr key={amenitySlot.amenitySlotId} className="hover:bg-gray-50">
//                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenitySlot.name}</td>
//                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenitySlot.amenityName}</td>
//                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenitySlot.startTime}</td>
//                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenitySlot.endTime}</td>
//                        <td className="px-6 py-4 whitespace-nowrap">
//                          <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${amenitySlot.activeStatus
//                            ? "bg-green-100 text-green-800"
//                            : "bg-red-100 text-red-800"
//                            }`}>
//                            {amenitySlot.activeStatus ? "Active" : "Inactive"}
//                          </span>
//                        </td>
//                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
//                          <button
//                            className="text-blue-500 hover:text-blue-700"
//                            onClick={() => handleView(amenitySlot.amenitySlotId)}
//                            title="View Slot"
//                          >
//                            <Eye size={18} />
//                          </button>
//                          <button
//                            className="text-gray-500 hover:text-gray-700"
//                            onClick={() => {
//                              setFormData({
//                                ...amenitySlot,
//                                startTime: amenitySlot.startTime?.slice(0, -3),
//                                endTime: amenitySlot.endTime?.slice(0, -3),
//                              });
//                              setShowAddModal(true);
//                            }}
//                            title="Edit Slot"
//                          >
//                            <Pencil size={18} />
//                          </button>
//                        </td>
//                      </tr>
//                    ))
//                  )}
//                </tbody>
//              </table>
//            </div>

//            <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
//              <div className="text-sm text-gray-700">
//                Page {currentPage + 1} of {pageCount}
//              </div>
//              <div className="flex-1 flex justify-end">
//                <Pagination
//                  currentPage={currentPage}
//                  pageCount={pageCount}
//                  setCurrentPage={setCurrentPage}
//                />
//              </div>
//            </div>
//          </div>
//        </div>
//      )}

//      {/* View Modal */}
//      <GlassmorphicModal
//        isOpen={showViewModal}
//        onClose={() => setShowViewModal(false)}
//        title="View Amenity Slot"
//        size="md"
//        footer={viewModalFooter}
//      >
//        {selectedAmenityType && (
//          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-1">Amenity Slot Name</label>
//              <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
//                {selectedAmenityType.name}
//              </div>
//            </div>
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-1">Amenity Name</label>
//              <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
//                {selectedAmenityType.amenityName}
//              </div>
//            </div>
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-1">Start Time</label>
//              <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
//                {selectedAmenityType.startTime}
//              </div>
//            </div>
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-1">End Time</label>
//              <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
//                {selectedAmenityType.endTime}
//              </div>
//            </div>
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-1">Active Status</label>
//              <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
//                {selectedAmenityType.activeStatus ? "Active" : "Inactive"}
//              </div>
//            </div>
//          </div>
//        )}
//      </GlassmorphicModal>

//      {/* Add/Edit Modal */}
//      <GlassmorphicModal
//        isOpen={showAddModal}
//        onClose={closeModal}
//        title={formData.amenitySlotId ? "Edit Amenity Slot" : "Add New Amenity Slot"}
//        size="lg"
//        footer={addModalFooter}
//      >
//        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Amenity Name <span className="text-red-500">*</span>
//            </label>
//            <select
//              value={formData.amenityId}
//              onChange={(e) => setFormData({ ...formData, amenityId: e.target.value })}
//              className={`w-full rounded-md border ${errors.amenityId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            >
//              <option value="">Select Amenity</option>
//              {amenities.map((amenity) => (
//                <option key={amenity.amenityid} value={amenity.amenityid}>
//                  {amenity.name}
//                </option>
//              ))}
//            </select>
//            {errors.amenityId && (
//              <p className="text-red-500 text-sm mt-1">{errors.amenityId}</p>
//            )}
//          </div>

//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Amenity Slot Name <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="text"
//              placeholder="Enter Amenity Slot Name"
//              value={formData.name}
//              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//              className={`w-full rounded-md border ${errors.name ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            />
//            {errors.name && (
//              <p className="text-red-500 text-sm mt-1">{errors.name}</p>
//            )}
//          </div>

//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Start Time <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="time"
//              value={formData.startTime}
//              onChange={(e) => setFormData({ ...formData, startTime: e.target.value })}
//              className={`w-full rounded-md border ${errors.startTime ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            />
//            {errors.startTime && (
//              <p className="text-red-500 text-sm mt-1">{errors.startTime}</p>
//            )}
//          </div>

//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              End Time <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="time"
//              value={formData.endTime}
//              onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
//              className={`w-full rounded-md border ${errors.endTime ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            />
//            {errors.endTime && (
//              <p className="text-red-500 text-sm mt-1">{errors.endTime}</p>
//            )}
//          </div>

//          {formData.amenitySlotId && (
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-2">Active Status</label>
//              <div className="flex gap-4">
//                <label className="inline-flex items-center cursor-pointer">
//                  <input
//                    type="radio"
//                    className="form-radio h-4 w-4 text-blue-500"
//                    checked={formData.activeStatus}
//                    onChange={() => setFormData({ ...formData, activeStatus: true })}
//                  />
//                  <span className="ml-2">Active</span>
//                </label>
//                <label className="inline-flex items-center cursor-pointer">
//                  <input
//                    type="radio"
//                    className="form-radio h-4 w-4 text-blue-500"
//                    checked={!formData.activeStatus}
//                    onChange={() => setFormData({ ...formData, activeStatus: false })}
//                  />
//                  <span className="ml-2">Inactive</span>
//                </label>
//              </div>
//            </div>
//          )}
//        </div>

//        {errorMessage && (
//          <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-md mt-4">
//            {errorMessage}
//          </div>
//        )}

//        <div className="text-sm text-red-500 mt-4">* indicates required field</div>
//      </GlassmorphicModal>
//    </div>
//  );
//};

//export default AddSlot;

import React, { useState, useEffect } from "react";
import Loading from "../../component/Loading/Loading";
import { FaRegWindowClose } from "react-icons/fa";
import { useSelector } from 'react-redux';
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { AiOutlineSortAscending } from "react-icons/ai";
import Pagination from "../../utils/Pagenation/Pagenation";
import useAxiosInstance from "../../services/useAxiosInstance";
import { Plus, Pencil, Eye, Search } from "lucide-react";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const AddSlot = () => {
    const axiosInstance = useAxiosInstance();
    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);
    const [amenitySlots, setAmenitySlots] = useState([]);
    const [amenities, setAmenities] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedAmenityType, setSelectedAmenityType] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        activeStatus: true,
        amenityId: 0,
        communityId: communityId,
        amenitySlotId: 0,
        name: "",
        startTime: "",
        endTime: "",
    });
    console.log(formData);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");

    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

    useEffect(() => {
        fetchAmenityTypes();
        fetchAmenities();
    }, []);

    const fetchAmenityTypes = () => {
        setIsLoading(true);
        axiosInstance
            .get(`/api/public/amenityslot/findByCommunityId/${communityId}`)
            .then((response) => {
                setAmenitySlots(response.data);
            })
            .catch((error) => {
                console.error("Error fetching amenity types:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchAmenities = () => {
        axiosInstance
            .get(`/api/public/amenity/findByCommunityId/${communityId}`)
            .then((response) => {
                console.log("Community ID:", communityId);
                console.log("Amenities data:", response.data);

                // Filter amenities based on activeStatus
                const filteredAmenities = response.data.filter(amenity =>
                    amenity.activeStatus === true || amenity.activeStatus === "true"
                );

                setAmenities(filteredAmenities);
            })
            .catch((error) => {
                console.error("Error fetching amenities:", error);
                setAlert({
                    visible: true,
                    message: 'Failed to fetch amenities',
                    type: 'error'
                });
            });
    };

    const handleView = (amenitySlotId) => {
        const selectedAmenity = amenitySlots.find(
            (amenitySlot) => amenitySlot.amenitySlotId === amenitySlotId
        );
        setSelectedAmenityType(selectedAmenity);
        setShowViewModal(true);
    };

    const closeModal = () => {
        setSelectedAmenityType(null);
        setShowDeleteModal(false);
        setShowViewModal(false);
        setShowAddModal(false);
        setFormData({
            activeStatus: true,
            amenityId: 0,
            amenitySlotId: 0,
            communityId: communityId,
            name: "",
            startTime: "",
            endTime: "",
        });
        setErrors({});
        setErrorMessage("");
    };

    const handleAddAmenityType = () => {
        setShowAddModal(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === "activeStatus" ? e.target.checked : value,
        });
    };

    const handleAddNewAmenitySlot = () => {
        const newErrors = {};

        if (!formData.amenityId) {
            newErrors.amenityId = "Amenity ID is required";
        }

        if (!formData.name) {
            newErrors.name = "Amenity Slot Name is required";
        }

        if (!formData.startTime) {
            newErrors.startTime = "Start Time is required";
        }

        if (!formData.endTime) {
            newErrors.endTime = "End Time is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const newAmenitySlotData = {
            ...formData,
            startTime: `${formData.startTime}:00`,
            endTime: `${formData.endTime}:00`,
        };
        setShowAddModal(false);
        setIsLoading(true);
        axiosInstance
            .post(`/api/public/amenityslot/amenityslot/add`, newAmenitySlotData)
            .then((response) => {
                setFormData({
                    activeStatus: true,
                    amenityId: 0,
                    amenitySlotId: 0,
                    communityId: communityId,
                    name: "",
                    startTime: "",
                    endTime: "",
                });
                console.log("Amenity slot added successfully:", response.data);
                setAlert({ visible: true, message: 'Amenity slot added successfully!', type: 'success' });
                fetchAmenityTypes();
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error adding new amenity slot:", error);
                setAlert({ visible: true, message: 'Error adding new amenity slot. Please try again', type: 'error' });
                setErrorMessage("Error adding new amenity slot. Please try again.");
                setIsLoading(false);
            });
    };

    const handleEditAmenitySlot = () => {
        const { amenitySlotId, ...updatedData } = formData;

        const newErrors = {};

        if (!updatedData.amenityId) {
            newErrors.amenityId = "Amenity ID is required";
        }

        if (!updatedData.name) {
            newErrors.name = "Amenity Slot Name is required";
        }

        if (!updatedData.startTime) {
            newErrors.startTime = "Start Time is required";
        }

        if (!updatedData.endTime) {
            newErrors.endTime = "End Time is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setShowAddModal(false);
        setIsLoading(true);
        axiosInstance
            .put(`/api/public/amenityslot/amenityslot/update/${amenitySlotId}`, updatedData)
            .then((response) => {
                setFormData({
                    activeStatus: true,
                    amenityId: 0,
                    amenitySlotId: 0,
                    communityId: communityId,
                    name: "",
                    startTime: "",
                    endTime: "",
                });
                console.log("Amenity slot updated successfully:", response.data);
                setAlert({ visible: true, message: 'Amenity slot updated successfully!', type: 'success' });
                fetchAmenityTypes();
                setIsLoading(false);
                const updatedAmenityTypes = amenitySlots.map((amenitySlot) =>
                    amenitySlot.amenitySlotId === amenitySlotId
                        ? { ...amenitySlot, ...updatedData }
                        : amenitySlot
                );
                setAmenitySlots(updatedAmenityTypes);
            })
            .catch((error) => {
                console.error("Error updating amenity slot:", error);
                setAlert({ visible: true, message: 'Error updating amenity slot. Please try again', type: 'error' });
                setErrorMessage("Error updating amenity slot. Please try again.");
                setIsLoading(false);
            });
    };

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;
    const [sortOrder, setSortOrder] = useState('none');

    const handleSort = () => {
        setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const sortedAmenitySlot = [...amenitySlots].sort((a, b) => {
        if (sortOrder === 'asc') {
            return a.name.localeCompare(b.name);
        } else if (sortOrder === 'desc') {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });
    const pageCount = Math.ceil(amenitySlots.length / itemsPerPage);
    const currentAmenitySlot = sortedAmenitySlot.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
    console.log(currentAmenitySlot);

    // Modal footers
    const viewModalFooter = (
        <div className="flex justify-end">
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={closeModal}
            >
                Close
            </button>
        </div>
    );

    const addModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                type="button"
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={formData.amenitySlotId ? handleEditAmenitySlot : handleAddNewAmenitySlot}
            >
                {formData.amenitySlotId ? "Update" : "Add"}
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {isLoading && <Loading />}
            {!isLoading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Amenity Slot</h1>
                        <div className="flex items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                onClick={handleAddAmenityType}
                            >
                                <Plus size={18} />
                                <span>Add Amenity Slot</span>
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Slot Name
                                            <button
                                                onClick={handleSort}
                                            >
                                                <AiOutlineSortAscending className="inline ml-1" />
                                            </button>
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amenity Name</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Start Time</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">End Time</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">active Status</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {currentAmenitySlot.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : (
                                        currentAmenitySlot.map((amenitySlot) => (
                                            <tr key={amenitySlot.amenitySlotId} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenitySlot.name}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenitySlot.amenityName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{amenitySlot.startTime}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{amenitySlot.endTime}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-left">
                                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${amenitySlot.activeStatus
                                                            ? "text-green-800 bg-green-100"
                                                            : "text-red-800 bg-red-100"
                                                        }`}>
                                                        {amenitySlot.activeStatus ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex justify-start gap-3">
                                                    <button
                                                        className="text-blue-500 hover:text-blue-700"
                                                        onClick={() => handleView(amenitySlot.amenitySlotId)}
                                                        title="View Slot"
                                                    >
                                                        <Eye size={18} />
                                                    </button>
                                                    <button
                                                        className="text-gray-500 hover:text-gray-700"
                                                        onClick={() => {
                                                            setFormData({
                                                                ...amenitySlot,
                                                                startTime: amenitySlot.startTime?.slice(0, -3),
                                                                endTime: amenitySlot.endTime?.slice(0, -3),
                                                            });
                                                            setShowAddModal(true);
                                                        }}
                                                        title="Edit Slot"
                                                    >
                                                        <Pencil size={18} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* View Modal */}
            <GlassmorphicModal
                isOpen={showViewModal}
                onClose={closeModal}
                title="View Amenity Slot"
                size="md"
                footer={viewModalFooter}
            >
                {selectedAmenityType && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Amenity Slot Name</label>
                            <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                                {selectedAmenityType.name}
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Amenity Name</label>
                            <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                                {selectedAmenityType.amenityName}
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Start Time</label>
                            <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                                {selectedAmenityType.startTime}
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">End Time</label>
                            <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                                {selectedAmenityType.endTime}
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Active Status</label>
                            <div className="w-full rounded-md border border-gray-300 bg-gray-50 px-4 py-2 text-gray-700">
                                {selectedAmenityType.activeStatus ? "Active" : "Inactive"}
                            </div>
                        </div>
                    </div>
                )}
            </GlassmorphicModal>

            {/* Add/Edit Modal */}
            <GlassmorphicModal
                isOpen={showAddModal}
                onClose={closeModal}
                title={formData.amenitySlotId ? "Edit Amenity Slot" : "Add New Amenity Slot"}
                size="lg"
                footer={addModalFooter}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Amenity Name <span className="text-red-500">*</span>
                        </label>
                        <select
                            value={formData.amenityId}
                            onChange={(e) => setFormData({ ...formData, amenityId: e.target.value })}
                            className={`w-full rounded-md border ${errors.amenityId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        >
                            <option value="">Select Amenity</option>
                            {amenities.map((amenity) => (
                                <option key={amenity.amenityid} value={amenity.amenityid}>
                                    {amenity.name}
                                </option>
                            ))}
                        </select>
                        {errors.amenityId && (
                            <p className="text-red-500 text-sm mt-1">{errors.amenityId}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Amenity Slot Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Amenity Slot Name"
                            maxLength={100}
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            className={`w-full rounded-md border ${errors.name ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {errors.name && (
                            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Start Time <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="time"
                            value={formData.startTime}
                            onChange={(e) => setFormData({ ...formData, startTime: e.target.value })}
                            className={`w-full rounded-md border ${errors.startTime ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {errors.startTime && (
                            <p className="text-red-500 text-sm mt-1">{errors.startTime}</p>
                        )}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            End Time <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="time"
                            value={formData.endTime}
                            onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
                            className={`w-full rounded-md border ${errors.endTime ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:ring-2 focus:ring-blue-500`}
                        />
                        {errors.endTime && (
                            <p className="text-red-500 text-sm mt-1">{errors.endTime}</p>
                        )}
                    </div>

                    {formData.amenitySlotId ? (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-3">Active Status:</label>
                            <div className="flex space-x-6">
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        id="activeCheckbox"
                                        checked={formData.activeStatus}
                                        onChange={() =>
                                            setFormData({ ...formData, activeStatus: true })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <span className="ml-2 text-sm text-gray-700">Active</span>
                                </label>
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        id="inactiveCheckbox"
                                        checked={!formData.activeStatus}
                                        onChange={() =>
                                            setFormData({ ...formData, activeStatus: false })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <span className="ml-2 text-sm text-gray-700">Inactive</span>
                                </label>
                            </div>
                        </div>
                    ) : null}
                </div>

                {errorMessage && (
                    <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-md mt-4">
                        {errorMessage}
                    </div>
                )}

                <div className="text-sm text-red-500 mt-4">* indicates required field</div>
            </GlassmorphicModal>
        </div>
    );
};

export default AddSlot;